import { arrayMove } from '@dnd-kit/sortable';
import api from 'api';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'components/modal';
import { useState, useEffect } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import './new-board-modal.scss';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { ContactType, RootState } from 'types';
import { toast } from 'react-toastify';
import { actions } from 'redux/reducers';

function NewBoardModal({...props}) {
    const params: any = useParams();
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.user);
    const [name, setName] = useState('');
    const [stages, setStages] = useState<any>([]);
    const [members, setMembers] = useState<any>([]);
    const [newStageName, setNewStageName] = useState('');
    const [clientContacts, setClientContacts] = useState<any>([]);
    const [loading, setLoading] = useState(false);

    const addStage = (e: any) => {
        if (e.key === "Enter") {
            setStages([...stages, newStageName])
            setNewStageName('');
        }
    }

    const onDragEnd = (e: any) => {
        const { source, destination } = e;
        if (!destination) return;
        if (source.index === destination.index) return;

        setStages(arrayMove(stages, source.index, destination.index))
    }

    const createNewBoard = () => {
        if (!name) { toast.warning("Please provide a name"); return; }
        if (!stages.length) { toast.warning("Please add at least 1 stage"); return; }

        setLoading(true);

        api.board.add(params.clientId, name).then((boardId: number) => {
            for (let i in stages) {
                api.column.add(boardId, stages[i], parseInt(i) + 1, 1);
            }
            for (let i in members) {
                api.board.member.add(boardId, members[i],  1);
            }
            api.board.getAll(params.clientId).then(data => {
                dispatch(actions.boards.set(data));
                setLoading(false);
                setName('');
                setStages([]);
                setMembers([]);
                setNewStageName('');
                props.setOpen(false);
            })
        });
    }

    useEffect(() => {
        api.clientContact.getAll(params.clientId).then((res: ContactType[]) =>{
            let resSorted = res.sort((a, b) => (a.Name < b.Name ? -1 : 1));
            setClientContacts(resSorted)
        });
    }, [params.clientId])

    return (
        <Modal open={props.open} setOpen={props.setOpen} id={props.id}>
            <ModalHeader>
                New Board
            </ModalHeader>
            <ModalBody>
                <div className="input-group">
                    <label>Please provide a name for the new board:</label>
                    <input type="text" placeholder="Name" value={name} onChange={e => setName(e.currentTarget.value)} />
                </div>
                <div className="input-group stages">
                    <label>Please specify the stages of this board:</label>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="stages" type="stage">
                            {(provided) => {
                                return (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                        {stages.map((x: any, i: number) => {
                                            return (
                                                <Draggable draggableId={x} index={i} key={x}>
                                                    {(provided, snapshot) => {
                                                        return (
                                                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                <span>{i + 1}.</span>
                                                                <input
                                                                    type="text"
                                                                    defaultValue={x}
                                                                    style={snapshot.isDragging ? { borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' } : {}}
                                                                    onBlur={e => setStages([...stages].splice(i, 1,  e.currentTarget.value))}
                                                                />
                                                            </div>
                                                        )
                                                    }}
                                                </Draggable>
                                            )
                                        })}
                                        {provided.placeholder}
                                    </div>
                                )
                            }}
                        </Droppable>
                    </DragDropContext>
                    <input type="text" className="new-stage" placeholder="New Stage" value={newStageName} onChange={e => setNewStageName(e.currentTarget.value)} onKeyUp={e => addStage(e)} />
                </div>
                <div className="input-group members">
                    <label>Please select the members of this board:</label>
                    {clientContacts.filter((x: any) => x.Id !== user?.Id).map((x: any, i: number) => {
                        return (
                            <div className="input-group" key={i}>
                                <input type="checkbox" value={x.Id} id={`check-${x.Id}`} checked={members.includes(x.Id)} onChange={() => setMembers([...members, x.Id])} />
                                <label htmlFor={`check-${x.Id}`}>{x.Name} {x.Surname}</label>
                            </div>
                        )
                    })}
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="button-group">
                    <button onClick={() => props.setOpen(false)}>Cancel</button>
                    <button className="btn-primary" onClick={createNewBoard}>{loading ? <i className="fal fa-spinner fa-spin"></i> : 'Save'}</button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default NewBoardModal;